import { useLayoutEffect, useState } from 'react';
import styles from './styles.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import { DriverInDriverOrder } from '../../../../types/carAllocation';
import LocationDetail from '../LocationDetail';
import EditSideBarHeader from '../EditSideBarHeader';

type RowProps = {
  formData: DriverInDriverOrder;
  user: number | null;
  headerCalendarOpen?: boolean;
};

const EditSideBar = ({ formData, user, headerCalendarOpen }: RowProps) => {
  const { setContainer, setExtra, extra } = useInitialScrollPosition();
  const [margin, setMargin] = useState<HTMLDivElement | null>(null);
  useDvhFallback(extra, margin, headerCalendarOpen);
  const [isOpened, setIsOpened] = useState(true);
  const value = formData.cars[0];

  if (
    !formData.cars[0] ||
    formData.cars[0].carAllocations.length === 0 ||
    !user
  ) {
    return <></>;
  }

  return (
    <div
      className={classNames(
        styles.host,
        headerCalendarOpen && styles.headerCalendarOpen
      )}
      ref={setContainer}
    >
      <button
        className={classNames(styles.openSideber, isOpened && styles.isOpen)}
        onClick={() => {
          setIsOpened(!isOpened);
        }}
      >
        <FontAwesomeIcon
          icon={isOpened ? faAngleRight : faAngleLeft}
          className={styles.icon}
        />
      </button>
      <div className={styles.halfModalExtra} ref={setExtra} />
      <div className={styles.halfModalMargin} ref={setMargin} />
      <div
        className={classNames(
          styles.sidebar,
          isOpened ? styles.open : styles.close
        )}
      >
        <div className={styles.head}>
          <EditSideBarHeader formData={formData.cars[0]} />
        </div>
        <div className={styles.locationDetail}>
          {value.carAllocations.map((c, count) => (
            <LocationDetail
              key={c.carAllocationId}
              formData={c}
              id={count + 1}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default EditSideBar;

/** 初期状態でハーフモーダルが画面下半分を覆うようにスクロール位置を調整する */
function useInitialScrollPosition() {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const [extra, setExtra] = useState<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    if (!container || !extra) return;
    container.scrollTop = extra.clientHeight;
  }, [container, extra]);

  return { setContainer, setExtra, extra };
}

/** ハーフモーダルのスクロール位置を決めるために使う dvh がサポートされていない環境のためのフォールバック */
function useDvhFallback(
  extra: HTMLDivElement | null,
  margin: HTMLDivElement | null,
  headerCalendarOpen = false
) {
  useLayoutEffect(() => {
    if (!extra || !margin) return;

    // サポート済みなら何もしない
    if (CSS.supports('height: 100dvh')) return;

    // dvh を使用している要素の高さを計算して指定する
    const updateHeight = () => {
      const rootHeight = document.documentElement.clientHeight;
      const calendarHeight = headerCalendarOpen ? 89 : 0;
      // CSS の指定と同じ計算式を使う
      extra.style.height = `${0.5 * rootHeight - 152}px`;
      margin.style.height = `${0.5 * rootHeight - 50 - 40 - calendarHeight}px`;
    };
    updateHeight();

    // dvh の変化 = ルート要素の大きさが変わる = resize イベントで再計算する
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, [extra, headerCalendarOpen]);
}
